import React, { useEffect, useState } from "react";
import logo from "../images/Logo.png";

function Loading() {
    const [dots, setDots] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prev => (prev + 1) % 4); // cycles: 0,1,2,3
        }, 500);
        return () => clearInterval(interval);
    }, []);

    const dotString = ".".repeat(dots);

    return (
        <div className="body">
            <img className="loading-logo" src={logo} alt="loading-logo" />
            <div className="loading-text">
                <div className="loading-text-loading">
                    Loading
                    <span className="dots">
                    {Array.from({ length: 3 }).map((_, i) => (
                        <span key={i} style={{ opacity: i < dots ? 1 : 0 }}>.</span>
                    ))}
                </span>
                </div>
            </div>
        </div>
    );

}

export default Loading;
